export function getValueAtPath(source, path, fallback = "") {
  const keys = String(path || "").split(".").filter(Boolean);
  let current = source;

  for (const key of keys) {
    if (current == null) return fallback;
    current = current[key];
  }

  return current == null ? fallback : current;
}

export function setValueAtPath(source, path, value) {
  const keys = String(path || "").split(".").filter(Boolean);
  if (!keys.length) return source;

  const root = Array.isArray(source) ? [...source] : { ...(source || {}) };
  let cursor = root;

  keys.forEach((key, index) => {
    const isLast = index === keys.length - 1;
    const nextKey = keys[index + 1];
    const nextShouldBeArray = /^\d+$/.test(nextKey || "");

    if (isLast) {
      cursor[key] = value;
      return;
    }

    const existing = cursor[key];
    if (Array.isArray(existing)) {
      cursor[key] = [...existing];
    } else if (existing && typeof existing === "object") {
      cursor[key] = { ...existing };
    } else {
      cursor[key] = nextShouldBeArray ? [] : {};
    }

    cursor = cursor[key];
  });

  return root;
}

export function settingsPayload(form, productsEnabled) {
  const productSections = productsEnabled
    ? form.sections
    : {
        ...form.sections,
        showSpotlight: false,
        showBrands: false,
        showProducts: false,
        showFeatured: false,
        showCategories: false,
      };

  return {
    publicStatus: form.publicStatus,
    business: form.business,
    navigation: form.navigation,
    hero: form.hero,
    catalog: form.catalog,
    about: form.about,
    highlightsIntro: form.highlightsIntro,
    highlights: form.highlights,
    contact: form.contact,
    footer: form.footer,
    messages: form.messages,
    appearance: form.appearance,
    theme: form.theme,
    seo: form.seo,
    sections: productSections,
  };
}
